import * as React from 'react';
import SeriesComponent from './series';
import { Series } from '../classes/series';
import { FestivalOverviewAppState } from '../classes/redux-states';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { getFestivalSeries, getSettings } from '../redux/actions/festival-overview-api';
import { FestivalOverviewSettingsModel } from '../redux/reducers/settings-reducer';
import { FestivalOverviewApiModel } from '../redux/reducers/festival-reducer';
import SeasonInfoComponent from './festival-info';
import { nodeListToArray } from '../../../Static/javascript/helpers/nodeListToArray';

export interface ExternalProps {
    seriesList: Series[];
    dayLabel: string;
}

interface StateToProps {
    state: FestivalOverviewAppState;
    settings: FestivalOverviewSettingsModel;
}



type SeriesListProps = StateToProps & ExternalProps;

export class SeriesListComponent extends React.Component<SeriesListProps, null> {
    constructor(props: SeriesListProps) {
        super(props);
    }

   

    render() {
        return (
            <div>
                <h2 className="season-overview-day-title" id="DayName">{this.props.dayLabel}</h2>
                <ul className="season-overview-list">
                    {
                        this.props.seriesList.map(series => <SeriesComponent series={series} key={this.props.seriesList.indexOf(series)} />)
                    }
                </ul>
            </div>
        )
    }
}

function mapStateToProps(state: FestivalOverviewAppState): StateToProps {
    return {
        settings: state.festivalOverviewSettingsModel,
        state: state
    }
}

export default connect(mapStateToProps, null)(SeriesListComponent)
